import { render, staticRenderFns } from "./SynthesisIcon.vue?vue&type=template&id=a5e55522&scoped=true"
import script from "./SynthesisIcon.vue?vue&type=script&lang=js"
export * from "./SynthesisIcon.vue?vue&type=script&lang=js"
import style0 from "./SynthesisIcon.vue?vue&type=style&index=0&id=a5e55522&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5e55522",
  null
  
)

export default component.exports